Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
ApiPromise = require 'network/api-promise'
Controller = require 'controller'
template = require 'views/templates/confirm_email'
View = require 'view'
_ = require 'underscore'

module.exports = class ConfirmEmailView extends View
  tagName: 'div'
  className: 'confirm-email-container'

  events:
    'click .js-logout': 'onLogout'
    'click .js-confirm-email-resend-with-return': 'onResendEmail'

  initialize: ({ @confirmReturnUrl }) ->
    @listenTo @model, 'change:oneTimeMessagesDismissed', @handleDismissedMessage
    @listenTo @model.boardList, 'update reset', @handleNewBoard

  render: ->
    @$el.html(template(email: @model.get('email')))
    @

  onLogout: ->
    Auth.forgetAccount()
    Auth.logoutPost('/')

  throttledSend: _.throttle (confirmReturnUrl) ->
    ApiPromise
      type: 'POST'
      url: '/resendValidate'
      data:
        email: Auth.me().get('email')
        confirmReturnUrl: confirmReturnUrl
    .then =>
      @showSuccessMessage()
      setTimeout(@hideSuccessMessage, 3000)
    .catch =>
      Alerts.show('could not send email', 'error', 'email', 5000)
  , 60000

  showSuccessMessage: ->
    @$('.js-show-resend-success').show()
    @$('.js-hide-resend-success').hide()

  hideSuccessMessage: ->
    @$('.js-show-resend-success').hide()
    @$('.js-hide-resend-success').show()

  onResendEmail: ->
    @throttledSend(@confirmReturnUrl)

  handleNewBoard: ->
    Controller.navigate @confirmReturnUrl, { trigger: true }

  handleDismissedMessage: ->
    if @model.isDismissed('create-first-board')
      Controller.navigate @confirmReturnUrl, { trigger: true }



// WEBPACK FOOTER //
// ./app/scripts/views/confirm-email/confirm-email-view.coffee